document.addEventListener("DOMContentLoaded", function () {
  const panels = document.querySelectorAll(".tab-panel");

  // Function to activate a specific tab and panel
  function activateTab(index) {
    // Get all tabs (both desktop and mobile)
    const allTabs = document.querySelectorAll(
      ".tab-content-titles li.tab-content-title"
    );

    // Remove active classes from all tabs and panels
    allTabs.forEach((t) => t.classList.remove("active-tab"));
    panels.forEach((p) => p.classList.remove("active-panel"));

    // Add active class to all tabs at this index (syncs desktop and mobile)
    allTabs.forEach((tab, i) => {
      if (i === index || i === index + allTabs.length / 2) {
        tab.classList.add("active-tab");
      }
    });

    // Activate the corresponding panel
    if (panels[index]) {
      panels[index].classList.add("active-panel");
    }
  }

  // Desktop tabs (first-two-tabs + remaining tabs)
  const desktopTabs = document.querySelectorAll(
    ".desk-structure li.tab-content-title"
  );
  desktopTabs.forEach((tab, index) => {
    tab.addEventListener("click", () => {
      activateTab(index);
    });
  });

  // Mobile tabs (tab-structure)
  const mobileTabs = document.querySelectorAll(
    ".tab-structure li.tab-content-title"
  );
  mobileTabs.forEach((tab, index) => {
    tab.addEventListener("click", () => {
      activateTab(index);
    });
  });
});
